/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { ListSuggestionsQueryResponse, ListSuggestionsQueryParams, ListSuggestionsHeaderParams, ListSuggestions401 } from "../../models/socialProfileSuggestionsController/ListSuggestions";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listSuggestionsQueryKey = (params?: ListSuggestionsQueryParams) => [{ url: '/social-profile-suggestions' }, ...(params ? [params] : [])] as const

export type ListSuggestionsQueryKey = ReturnType<typeof listSuggestionsQueryKey>

/**
 * {@link /social-profile-suggestions}
 */
export async function listSuggestions(params?: ListSuggestionsQueryParams, headers?: ListSuggestionsHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListSuggestionsQueryResponse, ResponseErrorConfig<ListSuggestions401>, unknown>({ method : "GET", url : `/social-profile-suggestions`, params, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function listSuggestionsQueryOptions(params?: ListSuggestionsQueryParams, headers?: ListSuggestionsHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listSuggestionsQueryKey(params)
        return queryOptions<ListSuggestionsQueryResponse, ResponseErrorConfig<ListSuggestions401>, ListSuggestionsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listSuggestions(params, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /social-profile-suggestions}
 */
export function useListSuggestions<TData = ListSuggestionsQueryResponse, TQueryData = ListSuggestionsQueryResponse, TQueryKey extends QueryKey = ListSuggestionsQueryKey>(params?: ListSuggestionsQueryParams, headers?: ListSuggestionsHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<ListSuggestionsQueryResponse, ResponseErrorConfig<ListSuggestions401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listSuggestionsQueryKey(params)
         

         const query = useQuery({
          ...listSuggestionsQueryOptions(params, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListSuggestions401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}